export const userHeaders = [
    { label: "Name", key: "name" },
    { label: "Email", key: "email" },
    { label: "Phone Number", key: "mobileNumber" },
    { label: "Role", key: "role" },
    { label: "Status", key: "status" },
    { label: "Created", key: "createdDate" },
    { label: "Actions", key: "action" },
];

